<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title text-center">Log In</h5>
            <div>
              <div class="mb-3">
                <label for="username" class="form-label">Username</label>
                <input type="text" class="form-control" v-model="username" id="username">
              </div>
              <div class="mb-3">
                <label for="password" class="form-label">Password</label>
                <div class="input-group">
                  <input :type="showPassword ? 'text' : 'password'" class="form-control" v-model="password" id="password">
                  <button type="button" class="btn btn-outline-secondary" @click="togglePasswordVisibility">
                    <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                  </button>
                </div>
              </div>
              <div class="form-check">
                <input type="checkbox" id="remember" v-model="remember">
                <label for="remember">Remember me</label>
              </div>
              <div class="text-danger" v-if="errorMessage">{{ errorMessage }}</div>
              <div class="d-grid">
                <button type="submit" class="btn btn-dark" @click="login">Log In</button>
              </div>
              <p class="text-center mt-3">Don't have an account? <router-link to="/register">Sign Up</router-link></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosInstance from '../router/axiosSetup';

export default {
  data() {
    return {
      username: '',
      password: '',
      errorMessage: '',
      showPassword: false,
      remember: false
    };
  },
  created() {
    // Check if user is already logged in when component loads
    this.checkExistingAuth();
  },
  methods: {
    async checkExistingAuth() {
      const token = localStorage.getItem('token');
      const role = localStorage.getItem('role');
      
      // If we have both a token and a role of admin or teacher
      if (token && (role === 'admin' || role === 'teacher')) {
        try {
          // Verify the token is still valid by making a quick request
          await axiosInstance.get('/admin/profile');
          
          this.$router.push('/admin');
        } catch (error) {
          localStorage.removeItem('token');
          localStorage.removeItem('role');
          localStorage.removeItem('userId');
          localStorage.removeItem('refreshToken');
        }
      }
    },
    // Renamed from debugLogin/performLogin to just login
    async login() {
      try {
        const response = await axiosInstance.post('/login', {
          username: this.username,
          password: this.password,
          remember: this.remember
        });
        
        // Only clear error message on success
        this.errorMessage = '';
        
        // Store token and user info
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('role', response.data.role);
        localStorage.setItem('userId', response.data.userId);
        
        if (this.remember && response.data.refreshToken) {
          localStorage.setItem('refreshToken', response.data.refreshToken);
        }
        
        this.$router.push('/admin');
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.errorMessage = 'Invalid username or password.';
        } else if (error.response && error.response.status === 429) {
          this.errorMessage = 'Too many login attempts. Please try again later.';
        } else {
          this.errorMessage = 'Login failed. Please try again: ' + (error.message || error);
        }
      }
    },
    
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    }
  },
  errorCaptured(err, vm, info) {
    console.error('Vue error captured:', err, info);
    return false;
  }
};
</script>